import { render } from "./GraveFastFood.vue?vue&type=template&id=575caf3a&scoped=true"
import script from "./GraveFastFood.vue?vue&type=script&lang=js"
export * from "./GraveFastFood.vue?vue&type=script&lang=js"

import "./GraveFastFood.vue?vue&type=style&index=0&id=575caf3a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-575caf3a"]])

export default __exports__